module.exports = __webpack_public_path__ + "img/image89.5f86a063.png";